import { getLocale } from '../../util/locales/locales';
import useSWR from 'swr';
import { StaticContentApiService } from '../../domain/static-content/static-content-api.service';
import {
  FooterStaticProps,
  HeaderProps,
  NavigationProps,
  NavItem,
  Section,
  GlobalLink,
} from '../../domain/static-content/static-content.static-generation.model';

interface UseStaticContentProps extends FooterStaticProps {
  header: HeaderProps;
  navigation: NavigationProps;
}

export const useStaticContent = ({
  footer = { legalEntity: '', sections: [] },
  header = {
    hasSecurity: true,
    profileMenuLinkScope: 'global_stihlIdProfile',
    hide: false,
    userInfoDataProvider: 'profile',
  },
  navigation = {
    hide: false,
    navItems: [],
  },
}: UseStaticContentProps): {
  navItems: NavItem[];
  sections: Section[];
  profileMenuItems: GlobalLink[];
} => {
  const navigationFetcher = StaticContentApiService.getNavigationLinksFetcher(getLocale(), navigation.scope);

  const { data: navItems = [] } = useSWR(navigation.hide ? null : navigationFetcher.key, navigationFetcher.fetcher, {
    fallbackData: navigation.navItems,
  });

  const footerFetcher = StaticContentApiService.getFooterLinksFetcher(getLocale(), footer.scope || 'global_footer');

  const { data: sections = [] } = useSWR(footer.hide ? null : footerFetcher.key, footerFetcher.fetcher, {
    fallbackData: footer.sections,
  });

  const profileFetcher = StaticContentApiService.getProfileLinksFetcher(
    getLocale(),
    header?.profileMenuLinkScope || 'global_stihlIdProfile'
  );

  const { data: profileMenuItems = [] } = useSWR(header?.hide ? null : profileFetcher.key, profileFetcher.fetcher, {
    fallbackData: header.profileMenuItems,
  });

  return { navItems, sections, profileMenuItems };
};
